import React from 'react';

const CustomerSection = ({
  filteredCustomersList,
  customers,
  custModelFilter,
  setCustModelFilter,
  custTypeFilter,
  setCustTypeFilter,
  masterModels
}) => {
  const style = {
    grid3: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '25px', marginBottom: '30px' },
    card: { background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 4px 25px rgba(0,0,0,0.05)', marginBottom: '30px' },
    kpiCard: { padding: '25px', borderRadius: '15px', color: 'white', display: 'flex', flexDirection: 'column', minHeight: '130px', justifyContent: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' },
    kpiTitle: { fontSize: '13px', fontWeight: '700', opacity: 0.85, marginBottom: '10px', letterSpacing: '0.5px' },
    kpiValue: { fontSize: '26px', fontWeight: 'bold' },
    input: { padding: '10px 15px', border: '1px solid #cbd5e1', borderRadius: '8px', outline: 'none', fontSize: '14px', background: 'white' },
    table: { width: '100%', borderCollapse: 'collapse', marginTop: '15px' },
    th: { background: '#f8fafc', padding: '14px 12px', textAlign: 'left', color: '#64748b', fontSize: '13px', fontWeight: 'bold', borderBottom: '2px solid #e2e8f0' },
    td: { padding: '14px 12px', fontSize: '14px', borderBottom: '1px solid #f1f5f9', color: '#1e293b' },
    badge: (bg, text) => ({ background: bg, color: text, padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold' })
  };

  return (
    <>
      <div style={style.grid3}>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #10b981, #059669)'}}>
          <div style={style.kpiTitle}>👥 조건 매칭 등록 고객 자산 계정</div>
          <div style={style.kpiValue}>{filteredCustomersList.length} 명</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #475569, #334155)'}}>
          <div style={style.kpiTitle}>📊 전체 누적 등록 회원수</div>
          <div style={style.kpiValue}>{customers.length} 명</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #6366f1, #4f46e5)'}}>
          <div style={style.kpiTitle}>🔒 데이터 보안 무결성 상태</div>
          <div style={style.kpiValue}>100% 무결</div>
        </div>
      </div>

      <div style={{...style.card, padding:'20px 30px', display:'flex', gap:'20px', alignItems:'center'}}>
        <span style={{fontWeight:'bold', fontSize:'15px'}}>🔍 교차 조건 스크리닝:</span>
        <div>
          <label style={{fontSize:'12px', fontWeight:'bold', marginRight:'10px'}}>• 소유 차종별</label>
          <select style={style.input} value={custModelFilter} onChange={e=>setCustModelFilter(e.target.value)}>
            <option value="전체">전체 차종</option>
            {masterModels.map(m=><option key={m.id} value={m.modelName}>{m.modelName}</option>)}
          </select>
        </div>
        <div>
          <label style={{fontSize:'12px', fontWeight:'bold', marginRight:'10px'}}>• 고객 구분별</label>
          <select style={style.input} value={custTypeFilter} onChange={e=>setCustTypeFilter(e.target.value)}>
            <option value="전체">전체 구분</option>
            <option value="개인">개인 고객</option>
            <option value="법인">법인 고객</option>
            <option value="정비업체">정비업체</option>
          </select>
        </div>
      </div>

      <div style={style.card}>
        <h3 style={{margin:'0 0 15px 0', fontSize:'16px'}}>👥 필터링 매칭 고객 목록</h3>
        <div style={{maxHeight:'400px', overflowY:'auto'}}>
          <table style={style.table}>
            <thead>
              <tr>
                <th style={style.th}>No</th>
                <th style={style.th}>고객명</th>
                <th style={style.th}>고객구분</th>
                <th style={style.th}>연계 차량번호</th>
                <th style={style.th}>핸드폰 번호</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomersList.map((c, idx)=>(
                <tr key={idx}>
                  <td style={style.td}>{idx + 1}</td>
                  <td style={style.td}><b>{c.name}</b></td>
                  <td style={style.td}>
                    <span style={style.badge(c.type==='정비업체'?'#fefce8':'#e0f2fe', c.type==='정비업체'?'#ca8a04':'#0369a1')}>
                      {c.type || '개인'}
                    </span>
                  </td>
                  <td style={style.td}>{c.carNumber || '-'}</td>
                  <td style={style.td}>{c.phone || '-'}</td>
                </tr>
              ))}
              {filteredCustomersList.length === 0 && <tr><td colSpan="5" style={{...style.td, textAlign:'center', color:'#94a3b8'}}>조건에 만족하는 고객 데이터 자산이 없습니다.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CustomerSection;